export const loadScript = src =>
  new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = src;
    script.async = true;
    script.onload = res => {
      resolve(true);
    };
    script.onerror = err => {
      reject(err);
    };
    document.body.appendChild(script);
  });



// WEBPACK FOOTER //
// ./src/functions/loadScript.js